<template>
  <li>
    <button
      class="search-toggle"
      :aria-pressed="dateFilterVisible ? 'true' : 'false'"
      @click="toggleDateFilter"
    >
      {{ t('dating') }}
      <svg
        class="ml-auto h-4 w-4"
        focusable="false"
        aria-hidden="true"
        width="16"
        height="16"
      >
        <use v-bind="{ 'xlink:href': '#arrow-down' }" />
      </svg>
    </button>
    <div class="pb-15 pt-10px text-xl" v-if="dateFilterVisible">
      <span class="sr-only" id="date">{{ t('date') }}</span>
      <span class="sr-only" id="from">{{ t('from') }}</span>
      <span class="sr-only" id="to">{{ t('to') }}</span>
      <input
        type="text"
        pattern="-?[0-9]*"
        inputmode="numeric"
        class="w-5ch"
        :placeholder="availableFilters.datings?.from"
        aria-labelledby="date from"
        @change="validate('from')"
        @keydown.enter="handleEnter('from')"
        v-model.number="from"
      />&ndash;<input
        type="text"
        pattern="-?[0-9]*"
        inputmode="numeric"
        class="ml-1ch w-5ch"
        :placeholder="availableFilters.datings?.to"
        aria-labelledby="date to"
        @change="validate('to')"
        @keydown.enter="handleEnter('from')"
        v-model.number="to"
      />
      <button
        type="button"
        class="-m-2 p-2"
        v-if="hasInput"
        @click="setDatingFilter"
      >
        <svg
          width="16"
          height="16"
          style="transform: rotate(180deg)"
          focusable="false"
          aria-hidden="true"
        >
          <use xlink:href="#arrow-left" />
        </svg>
      </button>
    </div>
  </li>
</template>

<i18n>
{
  "en": {
    "dating": "Date",
    "date": "Date",
    "from": "from",
    "to": "to"
  },
  "de": {
    "dating": "Datierung",
    "date": "Datum",
    "from": "ab",
    "to": "bis"
  }
}
</i18n>

<script lang="ts">
import { Ref, computed, defineComponent, ref, watch } from 'vue';
import { availableFilters, datingFilter } from '../utils/filter';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  setup() {
    const from: Ref<number | undefined> = ref(datingFilter.value?.from);
    const to: Ref<number | undefined> = ref(datingFilter.value?.to);
    const dateFilterVisible = ref(false);

    const toggleDateFilter = (): void => {
      dateFilterVisible.value = !dateFilterVisible.value;
    };

    const validate = (date: string): void => {
      if (from.value && to.value) {
        if (from.value > to.value) {
          if (date === 'from') {
            to.value = from.value;
          } else {
            from.value = to.value;
          }
        }
      }
    };

    const setDatingFilter = (): void => {
      if (from.value !== undefined || to.value !== undefined) {
        datingFilter.value = {
          from: typeof from.value !== 'string' ? from.value : undefined,
          to: typeof to.value !== 'string' ? to.value : undefined,
        };
      } else {
        datingFilter.value = undefined;
      }
    };

    const handleEnter = (date: string): void => {
      validate(date);
      setDatingFilter();
    };

    watch(datingFilter, (dating) => {
      if (dating) {
        from.value = dating.from;
        to.value = dating.to;
      } else {
        from.value = undefined;
        to.value = undefined;
      }
    });

    const hasInput = computed(() => {
      return from.value !== undefined || to.value !== undefined;
    });

    return {
      from,
      to,
      datingFilter,
      toggleDateFilter,
      dateFilterVisible,
      availableFilters,
      validate,
      setDatingFilter,
      handleEnter,
      hasInput,
      ...useI18n(),
    };
  },
});
</script>
